import * as React from "react";
import { styled } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Fab from "@mui/material/Fab";
import "../../../App.css";
import Link from "@mui/material/Link";
import FavoriteTwoToneIcon from "@mui/icons-material/FavoriteTwoTone";
import {
  useHistory,
  browserHistory,
  useMatch,
  useRouteMatch,
  useLocation,
} from "react-router-dom";
import "../../../assets/css/custom.css";

let enableNewUI = process.env.REACT_APP_NEWUI_LW;
const siteMedSrc = process.env.REACT_APP_MEDIA_SRC;
const navbarBGVariant = process.env.REACT_APP_NAVBAR_BGVARIANT;
const backgroundColor = process.env.REACT_APP_BACKGROUND_COLOR;
const enableSL = parseInt(process.env.REACT_APP_ENABLE_SL);

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      className="footerMenu"
      marginBottom="24px"
      {...props}
    >
      <br></br>
      <br />
      Made with <FavoriteTwoToneIcon sx={{ color: "#820813" }} /> by<br></br>
      <Link color="inherit" target="_blank" href="https://servingintel.com/">
        <img
          className="silogo"
          src={siteMedSrc + "si-logo" + ".svg"}
          alt="ServingIntel"
        />
      </Link>{" "}
    </Typography>
  );
}

const StyledFab = styled(Fab)({
  position: "absolute",
  zIndex: 1,
  top: 0,
  left: 0,
  right: 0,
  margin: "0 auto",
  width: "360px",
  backgroundColor: "transparent !important",
  boxShadow: "none !important",
  textTransform: "none",
});

export default function BottomMenuNav() {
  const history = useHistory();
  const { state } = useLocation();
  console.log(state);
  return (
    <React.Fragment>
      <AppBar
        position="relative"
        // id="footerMenu"
        sx={{
          boxShadow: 0,
          top: "auto",
          bottom: 0,
          backgroundColor: "transparent",
          // borderTop: "1px solid",
          // borderBottom: "1px solid",
          // borderColor: navbarBGVariant,
          height: "120px",
          // paddingBottom: "10px",
        }}
      >
        <Toolbar>
          {/* <IconButton
            color="inherit"
            className="btmLeftArrowHover"
            // href=""
            aria-label=""
            sx={{ zIndex: 9999, transform: "scale(1.5)", backgroundColor: "#005CB9", "&:hover": {backgroundColor: "#16497c"} }}   
            onClick={() =>{
              history.push({
                pathname: "/welcome",
                state
              });
            }}
             >         
          <ArrowBackTwoToneIcon sx={{ color:"#FFFFFF" }}/>
          </IconButton> */}
          <StyledFab
            style={{ width: "fit-content" }}
            id="nohover"
            disableautofocus
            disableenforcefocus
          >
            {enableNewUI == 1 || enableSL == 1 ? (
              <Copyright
                position="centered"
                sx={{
                  top: "auto",
                  bottom: 0,
                  "&:hover": { backgroundColor: "none" },
                  "&:focus": { backgroundColor: "none" },
                  "&:active": { backgroundColor: "none" },
                }}
              />
            ) : null}
          </StyledFab>
          <Box sx={{ flexGrow: 1 }} />
          {/* <IconButton  
            sx={ {zIndex: 99999, transform: "scale(1.5)", backgroundColor: backgroundColor, "&:hover": {backgroundColor: backgroundColor} }}     
            className="backArrowTopMenu" 
            color="inherit"
            href="/"
            aria-label=""
          >
            <LogoutTwoToneIcon sx={{ color:"#FFFFFF" }}/>
          </IconButton> */}
        </Toolbar>
      </AppBar>
    </React.Fragment>
  );
}
